var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 266,
    viewBox: "0 0 752 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_1_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.939149 215.15V161.08L107.997 6.08045H195.229L92.1366 161.08L52.4856 149.185H247.857V215.15H0.939149ZM131.788 258.406V215.15L134.311 149.185V110.615H214.334V258.406H131.788ZM372.098 264.173C349.749 264.173 329.924 259.006 312.622 248.673C295.56 238.34 282.102 223.32 272.25 203.615C262.637 183.91 257.831 160.119 257.831 132.243C257.831 104.367 262.637 80.5764 272.25 60.871C282.102 41.1656 295.56 26.1463 312.622 15.813C329.924 5.47969 349.749 0.313032 372.098 0.313032C394.447 0.313032 414.152 5.47969 431.214 15.813C448.517 26.1463 461.974 41.1656 471.586 60.871C481.439 80.5764 486.365 104.367 486.365 132.243C486.365 160.119 481.439 183.91 471.586 203.615C461.974 223.32 448.517 238.34 431.214 248.673C414.152 259.006 394.447 264.173 372.098 264.173ZM372.098 196.045C377.625 196.045 382.552 194.123 386.877 190.278C391.203 186.433 394.567 179.824 396.97 170.452C399.614 161.08 400.935 148.344 400.935 132.243C400.935 115.902 399.614 103.166 396.97 94.0338C394.567 84.6617 391.203 78.0532 386.877 74.2082C382.552 70.3633 377.625 68.4408 372.098 68.4408C366.571 68.4408 361.645 70.3633 357.319 74.2082C352.994 78.0532 349.509 84.6617 346.866 94.0338C344.463 103.166 343.261 115.902 343.261 132.243C343.261 148.344 344.463 161.08 346.866 170.452C349.509 179.824 352.994 186.433 357.319 190.278C361.645 194.123 366.571 196.045 372.098 196.045ZM503.357 215.15V161.08L610.415 6.08045H697.647L594.555 161.08L554.903 149.185H750.275V215.15H503.357ZM634.206 258.406V215.15L636.729 149.185V110.615H716.752V258.406H634.206Z",
    fill: "#E5E5DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_1_1389",
    x: 0.00000488758,
    y: 0.00000160933,
    width: 751.214,
    height: 266.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.626095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.469572
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1389",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_1_1389"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.35863
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56524
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_1_1389",
    result: "effect3_innerShadow_1_1389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.94eb7e93dafb06d7d8a5c927ff4d4abc.svg";
export { ForwardRef as ReactComponent };